<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="first" style="text-align: center;">
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1008<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	Copyright © 2014 by The Washington Post<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">
<span style="font-size: 1em; line-height: 1.5; text-indent: 0em;">For more information, email </span><a href="mailto:info@diversionbooks.com" style="font-size: 1em; line-height: 1.5; text-indent: 0em;">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	First Diversion Books edition September 2014<br/>
	ISBN: 978-1-62681-410-3</p>
<p style="text-align: center;">
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap271577.vue?d81f9e4e